module.exports = __webpack_public_path__ + "img/twitter.4842c235.svg";